export const METHOD_TYPES = {
  GET: 'get',
  POST: 'post',
  UPDATE: 'put',
  PATCH: 'patch',
  DELETE: 'delete',
};

export const API_STATUS_CODE = {
  zero: 0,
  statusOk: 200,
  statusMultiChoice: 300,
  statusError: 400,
  internalServerError: 500,
  notFound: 404,
  unauthorized: 401,
  forbidden: 403,
  notAcceptable: 406,
  alreadyExists: 409,
};

export const ERROR = 'ERROR';
export const SUCCESS = 'SUCCESS';
export const EMAIL_PREFERENCE_LOGIN_RESPONSE_VALID = 'valid';

export const SMARTY_STREETS_LOOKUP_FIELDS = {
  search: 'search',
  key: '82925047705455899',
  includeOnlyZipCodes: 'include_only_zip_codes',
  preferGeolocation: 'prefer_geolocation',
};

export const ACCEPT_JS_API_CREDENTIALS = {
  test: {
    apiLoginID: '326GkEswFD',
    clientKey: '66YY8ECppHZq76tkTR2S37t6uMf8y256BdAcYd4jc6ef5K6h4z8JKZpH96jktr2m',
  },
  prod: {
    apiLoginID: '3k72qBRx37Y',
    clientKey: '32cPpY4z4unbL87mBX2Uy7qPv4kvz4R6RR7k4zub2FeGFEp9Nkf4VQ5FSb7NcWPG',
  },
};

export const UPDATE_CUSTOMER_EMAIL_PREFERENCE_DATA_FIELDS = {
  updateEmail: 'updateEmail',
  updateLoginName: 'updateLoginName',
  updateUserId: 'updateUserId',
  updateField: 'updateField',
  updateValue: 'updateValue',
  updateHMCId: 'updateHMCId',
  updateHMCAttributeId: 'updateHMCAttributeId',
  updateHMCAttributeValue: 'updateHMCAttributeValue',
};

export const NO_GEO_LOCATION = 'none';

/* Member Center Basic Auth Starts - Do not Alter */
const memberCenterUsername = 'member-center-api';
const memberCenterPassword = 'T3n7hF8TxEZ8zFEZ';
export const MEMBER_CENTER_BASIC_AUTH = `Basic ${btoa(`${memberCenterUsername}:${memberCenterPassword}`)}`;
/* Member Center Basic Auth Ends */

export const AXIOS_REQUEST_TIMEOUT = 5000;
export const AXIOS_REQUEST_TIMEOUT_TEN_SECONDS = 10000;
export const AXIOS_REQUEST_TIMEOUT_THIRTY_SECONDS = 30000;

export const ORDER_HISTORY_API_PARAMS = {
  PAGE_NUMBER: 1,
  PAGE_SIZE: 20,
};

export const REMOVE_MYWALLET_CARD_DATA_FIELDS = {
  removeCardId: 'removeCardId',
  removeProfileId: 'removeProfileId',
  removePaymentId: 'removePaymentId',
};
export const HASH_METHOD_SHA256_BCRYPT = 'SHA256-BCRYPT';

export const EDIT_MYWALLET_CARD_DATA_FIELDS = {
  updatePaymentId: 'updatePaymentId',
  updateExpDate: 'updateExpDate',
  updatePaymentCustomerId: 'updatePaymentCustomerId',
  updatePaymentProfileId: 'updatePaymentProfileId',
  updateDefault: 'updateDefault',
  updateLastFour: 'updateLastFour',
  updateDrfCustomerId: 'updateDrfCustomerId',
};
